// extracted by mini-css-extract-plugin
export default {"results":"PriceFilter__results--mCGfn","priceRange":"PriceFilter__priceRange--AAdPZ"};